<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { BtnLink } from '@shared/ui/links'

import { useCustomerInfo } from '../model/customer-info.hook'

defineOptions({
  name: 'CustomerIntegrationInfo',
})

const {
  refLinks,
} = useCustomerInfo()
</script>

<template>
  <div class="customer-info-group">
    <AppText name="body1-medium">
      Links
    </AppText>
    <div class="customer-info-group__links">
      <BtnLink
        v-for="link in refLinks"
        :key="link.name"
        :link-name="link.name"
        :link-url="link.url"
        :link-id="link.id"
      >
        <template
          v-if="link.image"
          #iconLeft
        >
          <img
            :src="link.image"
            :width="link.imageWidth ?? undefined"
            :alt="link.name"
          >
        </template>
      </BtnLink>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerInfoGroup.scss" />
